import { Box, Typography, CircularProgress } from "@mui/material";
import DashboardPaper from "./DashboardPaper";
import { CmLink } from "./CmLink";

interface ChartContainerProps {
  title: string;
  action?: React.ReactNode;
  loading?: boolean;
  // When set, the whole card becomes a link to this path (matching the dashboard StatCards).
  href?: string;
  children: React.ReactNode;
}

export default function ChartContainer({ title, action, loading, href, children }: ChartContainerProps) {
  return (
    <DashboardPaper
      {...(href ? { component: CmLink, to: href } : {})}
      sx={{
        p: 3,
        flex: { xs: "1 1 100%", md: "1 1 50%" },
        display: "flex",
        flexDirection: "column",
        ...(href && {
          textDecoration: "none",
          color: "inherit",
          cursor: "pointer",
          transition: "border-color 0.2s, box-shadow 0.2s",
          "&:hover": { borderColor: "#9cb9ff", boxShadow: 3 },
        }),
      }}
    >
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        {action}
      </Box>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1, minHeight: 300 }}>
            <CircularProgress />
          </Box>
        ) : (
          children
        )}
      </Box>
    </DashboardPaper>
  );
}
